<template>
  <v-card :loading="loading">
    <v-card-title class="d-flex justify-space-between align-top">
      <EditableField v-model="report.name" label="Name" :editing="editing" @commit="edit">
        <a :href="`/reporting/reports/${report.id}`" class="text-decoration-none w-100">
          {{ report.name }}
        </a>
      </EditableField>

      <div class="d-flex ga-1">
        <v-btn
          v-if="report.can.update"
          size="small"
          variant="text"
          :icon="updateButtonStyle.icon"
          :color="updateButtonStyle.color"
          @click="edit"
        />
        <v-btn v-if="report.can.destroy" icon="mdi-delete" size="small" variant="text" color="error" @click="destroy" />
      </div>
    </v-card-title>

    <v-card-text class="d-flex ga-2">
        <div class="areas-count">
          <div class="text-h5">{{ report.areas_count }}</div>
          <div class="text-caption text-medium-emphasis">Flächen</div>
        </div>
        <div class="flex-grow-1">
          <div>{{ report.constraints.area.min }} bis {{ report.constraints.area.max }} m²</div>
          <div v-if="report.district">in {{ report.district.name }}</div>
        </div>
    </v-card-text>

    <v-card-actions>
      <small class="text-medium-emphasis">{{ report.created_at }}</small>
      <v-spacer />
      <a class="text-body-small" :href="`/organisations/${report.organisation?.id}`">{{ report.organisation?.name }}</a>
    </v-card-actions>
  </v-card>
</template>

<script setup>
  import EditableField from "../common/EditableField.vue";
  import { ref, computed, inject } from "vue";
  import { useFlashStore } from "../../stores/flash";
  import { useCommandStore } from "../../stores/command";

  const emit = defineEmits(["destroy"]);
  const flash = useFlashStore();
  const command = useCommandStore();
  const report = defineModel();
  const editing = ref(false);
  const loading = ref(false);
  const updateButtonStyle = computed(() => {
    return {
      icon: editing.value ? "mdi-check" : "mdi-pencil",
      color: editing.value ? "success" : "primary",
    };
  });

  async function edit() {
    if (editing.value) {
      loading.value = true;
      const data = await command.execute(
        "Reporting::Report",
        "update",
        {
          id: report.value.id,
          reporting_report: { name: report.value.name }
        }
      );
      loading.value = false;
      if (data.success) {
        editing.value = !editing.value;
      } else {
        data.errors.forEach(flash.error);
      }
    } else {
      editing.value = true;
    }
  }

  async function destroy() {
    loading.value = true;
    const data = await command.execute(
      "Reporting::Report",
      "destroy",
      { id: report.value.id }
    );
    loading.value = false;
    if (data.success) {
      emit("destroy", report.value);
    } else {
      data.errors.forEach(flash.error);
    }
  }
</script>

<style scoped>
  a.text-body-small {
    font-size: 0.75rem;
  }

  .areas-count {
    width: 6rem;
  }
</style>
